import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'reactstrap';

import AdminFTPQueueListHeader from './ListHeader';
import AdminFTPQueueListItem from './ListItem';

const AdminFTPQueueList = ({ files, ...props }) => (
  <div className="table-wrapper">
    <Table className="files-list queue-list" responsive>
      <thead>
        <AdminFTPQueueListHeader
          {...props}
        />
      </thead>
      <tbody>
        {files.map(file => (
          <AdminFTPQueueListItem
            key={file.id}
            file={file}
          />
        ))}
      </tbody>
    </Table>
  </div>
);

AdminFTPQueueList.propTypes = {
  files: PropTypes.array.isRequired,
  orderBy: PropTypes.string.isRequired,
  order: PropTypes.string.isRequired,
  handleChangeOrder: PropTypes.func.isRequired,
};

export default AdminFTPQueueList;
